import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { Indexador } from 'src/app/model/dominio-operacao.model';
import { TaxaJurosEquivalente } from 'src/app/model/taxa-juros-equivalente.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { TaxaJurosEquivalenteService } from 'src/app/shared/services/taxa-juros-equivalente.service';

@Component({
    selector: 'app-taxa-juros-equivalente-listagem',
    templateUrl: './taxa-juros-equivalente-listagem.component.html',
    styleUrls: ['./taxa-juros-equivalente-listagem.component.scss'],
    standalone: false
})
export class TaxaJurosEquivalenteListagemComponent implements OnInit {

    public taxasJurosEquivalentes: TaxaJurosEquivalente[] = [];

    public taxasExibidas: TaxaJurosEquivalente[] = [];

    public indexadores: Indexador[];

    public opcoesPaginacao = [10, 15, 20];

    public page = 1;

    public pageSize = 10;

    public permissaoEdicao = false;

    constructor (private taxaJurosEquivalenteService: TaxaJurosEquivalenteService,
        private activatedRoute: ActivatedRoute,
        private permissaoService: PermissaoService) {
    }

    private atualizaTaxasExibidas() {
        let fim = this.taxasJurosEquivalentes.length;
        if (fim > this.page * this.pageSize) {
            fim = this.page * this.pageSize;
        }
        this.taxasExibidas = this.taxasJurosEquivalentes.slice((this.page-1) * this.pageSize, fim);
    }

    public adicionarTaxaJurosEquivalente() {
        let taxa = new TaxaJurosEquivalente();
        taxa.modoEdicao = true;
        this.getTaxasJurosEquivalentes().unshift(taxa);
        this.atualizaTaxasExibidas();
    }

    private getTaxasJurosEquivalentes(): TaxaJurosEquivalente[] {
        return this.taxasJurosEquivalentes;
    }

    private setTaxasJurosEquivalentes(taxasJurosEquivalentes: TaxaJurosEquivalente[]) {
        if (taxasJurosEquivalentes) {
            for (let taxa of taxasJurosEquivalentes) {
                taxa.dataInicioValidade = this.ajustaCampoDate(taxa.dataInicioValidade);
            }
        }
        return this.taxasJurosEquivalentes = taxasJurosEquivalentes;
    }

    public atribuiIndexador(taxa: TaxaJurosEquivalente, indexador: number) {
        taxa.indexador = indexador;
    }

    public salvarTaxaJurosEquivalente(taxa: TaxaJurosEquivalente) {
        this.taxaJurosEquivalenteService.salvar(taxa).subscribe((resp) => {
            resp.dataInicioValidade = this.ajustaCampoDate(resp.dataInicioValidade);
            const pos = this.getTaxasJurosEquivalentes().indexOf(taxa);
            this.getTaxasJurosEquivalentes()[pos] = resp;
            this.atualizaTaxasExibidas();
        });
    }

    public removerTaxaJurosEquivalente(taxa: TaxaJurosEquivalente) {
        if (taxa.id) {
            this.taxaJurosEquivalenteService.remover(taxa.id).subscribe(() => {
                const pos = this.getTaxasJurosEquivalentes().indexOf(taxa);
                this.getTaxasJurosEquivalentes().splice(pos, 1);
                this.atualizaTaxasExibidas();
            });
        }
        else {
            const pos = this.getTaxasJurosEquivalentes().indexOf(taxa);
            this.getTaxasJurosEquivalentes().splice(pos, 1);
            this.atualizaTaxasExibidas();
        }
    }

    public editarTaxaJurosEquivalente(taxa: TaxaJurosEquivalente) {
        taxa.dataInicioValidadeOriginal = taxa.dataInicioValidade;
        taxa.indexadorOriginal = taxa.indexador;
        taxa.taxaJurosEquivalenteOriginal = taxa.taxaJurosEquivalente;
        taxa.modoEdicao = true;
    }

    public cancelarEdicaoTaxaJurosEquivalente(taxa: TaxaJurosEquivalente) {
        if (taxa.id) {
            taxa.dataInicioValidade = taxa.dataInicioValidadeOriginal;
            taxa.indexador = taxa.indexadorOriginal;
            taxa.taxaJurosEquivalente = taxa.taxaJurosEquivalenteOriginal;
            taxa.modoEdicao = false;
        }
        else {
            this.removerTaxaJurosEquivalente(taxa);
        }
    }
    
    public ngOnInit() {
        this.indexadores = this.activatedRoute.snapshot.data['dominios'].indexadores; //resolver

        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            if (resp && resp[ROLE_GESTOR_ENVIO]) {
                this.permissaoEdicao = true;
            }
        });

        this.taxaJurosEquivalenteService.buscarTodos().subscribe(resp => {
            this.setTaxasJurosEquivalentes(resp);
            this.atualizaTaxasExibidas();
        });
    }

    public mudancaPagina(evento) {
        this.page = evento.page;
        this.pageSize = evento.pageSize;
        this.atualizaTaxasExibidas();
    }

    ajustaCampoDate(data:any) {
        if (typeof data === 'string') {
          if (data.length == 10) {
            data += ' 00:00:00';
          }
          return new Date(data);
        }
    
        return data;
      }
}